import React from "react";
import { Row, Col } from "react-bootstrap";
import '../../../src/App.css';
import './ExploreSection.css';

import ex_logo from '../../assets/explore-logo.png';
import logo from '../../assets/logo_png_para_web.png';


const ExploreSection = () => {
  return(
    <section id="explore-section">    
      <Col lg={9} className="offset-lg-3 paddingTop50px text-start">
        <Row>
          <Col lg={12}>
            <img src={ex_logo} alt="Explore logo" className="img-fluid" />
            <p className="fs-1 font-nunito fw-bold text-start explore-title spacing_letter_6px">
              Explora lo que <img src={logo} alt="Data Dos" className="logo-explore img-fluid" /> ya está<br/>
              haciendo.
            </p>
          </Col>
        </Row>        
      </Col>
      <Row className="d-flex justify-content-center">
        {/* 1era Imagen */}
        <Col lg={4} className="img-card-1 position-relative">
          {/* Título y Descripción */}
          <div className="explore-card-content d-flex flex-column justify-content-end">
            <div className="col-lg-8">
              <p className="explore-card-title mb-0">Empleados</p>
            </div>
            <div className="col-lg-12">
              <p className="explore-card-description">
                Optimización del tiempo y <br />
                control de empleados con IA.
              </p>
            </div>            
          </div>
        </Col>        
        {/* 2da Imagen */}
        <Col lg={4} className="img-card-2 position-relative">
          {/* Título y Descripción */}
          <div className="explore-card-content d-flex flex-column justify-content-end">
            <div className="col-lg-8">
              <p className="explore-card-title mb-0">Análisis del Negocio</p>
            </div>
            <div className="col-lg-12">
              <p className="explore-card-description">
                Análisis descriptivo de tus<br />
                productos y margen de beneficio.              
              </p>
            </div>            
          </div>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center">
        {/* 3era Imagen */}
        <Col lg={4} className="img-card-3 position-relative">
          {/* Título y Descripción */}
          <div className="explore-card-content d-flex flex-column justify-content-end">
            <div className="col-lg-8">
              <p className="explore-card-title mb-0">Redes Sociales</p>
            </div>
            <div className="col-lg-12">
              <p className="explore-card-description">
                Percepción de Marca y Análisis<br/>
                de opiniones.
              </p>
            </div>            
          </div>
        </Col>        
        {/* 4ta Imagen */}
        <Col lg={4} className="img-card-4 position-relative">
          {/* Título y Descripción */}
          <div className="explore-card-content d-flex flex-column justify-content-end">
            <div className="col-lg-8">
              <p className="explore-card-title mb-0">Ventas y Mercado</p>
            </div>
            <div className="col-lg-12">
              <p className="explore-card-description">
                Eficiencia en Ventas y<br />
                Conocimiento del Mercado.
              </p>
            </div>            
          </div>
        </Col>
      </Row>
      <Col lg={12} className="marginTop5_per">
        <p className="fs-5 font-montserrat text-center custom-bg spacing_letter_6px">
          Hazlo ahora, trabaja con los datos ya!!!.
        </p>
      </Col>
    </section>
  )

}
export default ExploreSection;